import React from 'react';

/**
 * ProgressBar — thin bar at top of header showing section progress.
 * @param {number} current - 0-indexed current section (0 = Section 0)
 * @param {number} total   - total number of sections (9: S0–S8)
 */
function ProgressBar({ current, total }) {
  const pct = Math.round(((current + 1) / total) * 100);

  return (
    <div>
      <div className="progress-bar-wrap">
        <div
          className="progress-bar-fill"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={current + 1}
          aria-valuemin={1}
          aria-valuemax={total}
        />
      </div>
      <span className="progress-label">
        Section {current + 1} of {total}
      </span>
    </div>
  );
}

export default ProgressBar;
